import React from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import { Col, Row, Spinner } from "react-bootstrap";
import GameListCard from "src/components/ElectronicGamingDevices/GameListCard";
import { useHubCardLivePreview } from "src/hooks/useHubCardLivePreview";
import { mapEgdGame } from "src/utils/mapEgdGame";
import { egdLivePreviewRequestHandler } from "src/utils/egdLivePreviewHandler";

const EgdGameCardPreview = () => {
  const { t, i18n } = useTranslation();
  const { card: game, isLoading } = useHubCardLivePreview(
    "egd",
    { depth: 1, mapDoc: mapEgdGame, requestHandler: egdLivePreviewRequestHandler },
    i18n.language
  );

  return (
    <PreviewPage>
      <container-wide>
        <Row className="g-4 justify-content-center" xs={1}>
          {isLoading ? (
            <div className="d-flex justify-content-center align-items-center w-100 py-5">
              <Spinner animation="border" variant="light" role="status">
                <span className="visually-hidden">{t("loading")}</span>
              </Spinner>
            </div>
          ) : !game ? (
            <div className="preview-status py-5 w-100">
              <p>{t("egd.egdGameList.preview.waitingForDocument")}</p>
            </div>
          ) : (
            <Col xs={12} md={10} lg={8} xl={6}>
              <GameListCard game={game} />
            </Col>
          )}
        </Row>
      </container-wide>
    </PreviewPage>
  );
};

const PreviewPage = styled.div`
  padding: 1.5rem 0 2rem;
  min-height: 100vh;
  background: var(--black);
  color: var(--white);

  .preview-status {
    text-align: center;
    color: var(--mutedwhite);
  }
`;

export default EgdGameCardPreview;
